const inputVariants = {
    default: { fontSize: 'smallest', lineHeight: '15px', paddingY: '7px' },
    large: { fontSize: 'small', lineHeight: '18px', paddingY: '9px' },
    largest: { fontSize: 'default', lineHeight: '24px' },
};
export default inputVariants;
/** @typedef {keyof inputVariants} InputVariant */
//# sourceMappingURL=inputVariants.js.map